module.exports = __webpack_public_path__ + "static/img/Bachelor_010783.1e55ab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010783.jpg
// module id = 245
// module chunks = 0